export const estadosContrato = {
  vigente: { label: 'Vigente', color: 'bg-green-100 text-green-700' },
  finalizado: { label: 'Finalizado', color: 'bg-slate-100 text-slate-700' },
  rescindido: { label: 'Rescindido', color: 'bg-red-100 text-red-700' },
};

export const estadosDeposito = {
  vigente: { label: 'Vigente', color: 'bg-green-100 text-green-700' },
  devuelto: { label: 'Devuelto', color: 'bg-slate-100 text-slate-700' },
};

export const initialContratoForm = {
  // Tipo de inquilino: 'humana' | 'juridica' (default juridica para compat)
  tipo_inquilino: 'juridica',
  // Datos firmante (persona humana)
  firmante_nombre: '',
  firmante_email: '',
  firmante_whatsapp: '',
  nombre_comercial: '',
  razon_social: '',
  descripcion_empresa: '',
  fecha_inicio: '',
  fecha_fin: '',
  monto_inicial: '',
  monto_actual: '',
  moneda: 'ARS',
  indice_tipo: 'ipc',
  indice_frecuencia: 'trimestral',
  // Multi-índice + Valor referencia USD (Jun 2026)
  ajuste_indices: [{ tipo: 'IPC', peso: 100 }],
  ajuste_frecuencia: 'trimestral',
  valor_referencia: null,
  indice_valor: '',
  indice_condiciones: '',
  archivo_contrato_id: null,
  // Contactos
  contacto_comercial_nombre: '',
  contacto_comercial_email: '',
  contacto_comercial_telefono: '',
  contacto_comercial_mismo_firmante: true,  // humana: por default mismo que firmante
  contacto_admin_nombre: '',
  contacto_admin_email: '',
  contacto_admin_telefono: '',
  contacto_admin_mismo_firmante: true,  // humana: mismo que firmante
  contacto_admin_mismo_comercial: true, // juridica: mismo que comercial
  // Acceso a plataforma (usuario de acceso al sistema)
  acceso_nombre: '',
  acceso_email: '',
  acceso_mismo_firmante: true,   // humana: por default usa firmante
  acceso_mismo_admin: true,      // juridica: por default usa contacto admin
  // Datos fiscales
  cuit: '',
  domicilio_fiscal: '',
  condicion_iva: '',
  email_facturacion: '',
  emails_facturacion: [''],
  email_facturacion_default: true,  // jurídica: true → toma del admin
  orden_compra: '',
  orden_compra_tipo: '', // '' (sin OC), 'anual', 'mensual'
  orden_compra_instruccion: '',
  // Plataforma de proveedores + facturación contacto + emergencia (Fase 3)
  proveedor_plataforma_nombre: '',
  proveedor_plataforma_url: '',
  proveedor_plataforma_usuario: '',
  proveedor_plataforma_password: '',
  proveedor_plataforma_instrucciones: '',
  facturacion_mismo_admin: true,
  facturacion_metodo: 'email',
  facturacion_contacto_nombre: '',
  facturacion_contacto_apellido: '',
  facturacion_contacto_telefono: '',
  facturacion_contacto_email: '',
  emergencia_nombre: '',
  emergencia_telefono: '',
  emergencia_email: '',
  // Datos de cobro
  dia_emision: '',
  dia_vencimiento: '',
  penalidad_enabled: false,
  penalidad_dias_gracia: 10,
  penalidad_porcentaje_1: 10,
  penalidad_porcentaje_2: 20,
  // Colppy
  colppy_nro_factura: '004',
  colppy_factura_electronica: true,
  colppy_condicion_venta: 'cuenta_corriente',
  colppy_tipo_comprobante: '',
  colppy_tipo_factura: '',
  colppy_descripcion: '',
  colppy_tipo_operacion: 'servicios',
  colppy_punto_venta: '',
  colppy_cuenta_contable: '',
  colppy_cuenta: '',
  colppy_moneda: 'ARS',
  colppy_percepciones: false,
  // Cochera
  incluye_cochera: false,
  cocheras_incluidas: [], // Array de IDs de unidades tipo cochera
  cocheras_config: {}, // { unidad_id: { tipo_cochera: 'estandar'|'personalizado', monto: number } }
  // Comisión (solo comercial)
  porcentaje_comision: 50,
};

export const initialDepositoForm = {
  tipo_deposito: 'dinero',
  monto: '',
  moneda: 'ARS',
  fecha_cobro: '',
  medio_cobro: 'transferencia',
  cuenta_destino: '',
  documento: null,
};
